import type { Networkish } from "@/types";
import React, { useMemo } from "react";

import useSupportedChains from "@/hooks/api/useSupportedChains";
import { SupAvatar, SupAvatarGroup } from "@repo/core-ui";

interface SupUiMultiTagProps {
  chains: Networkish[] | null;
  showNames?: boolean;
}

export default function SupUiMultiTag({ chains, showNames = false }: SupUiMultiTagProps) {
  const { data } = useSupportedChains();

  const chainData = useMemo(() => {
    if (!chains) return [];
    return chains.map((chain: Networkish) => {
      return data?.find(chainData => chainData.chain_id === chain);
    });
  }, [chains, data]);

  return (
    chainData.length > 0 && (
      <div className="relative flex w-full items-center">
        <SupAvatarGroup className="-space-x-4" border="ring" variant="circular" avatarClassName="bg-[#F4F3F7]">
          {chainData.map(
            (singleChain, index) =>
              singleChain && (
                <SupAvatar key={`chain_logo_${index}`}>
                  <img className="test" src={singleChain.icon} alt={singleChain.name} />
                </SupAvatar>
              )
          )}
        </SupAvatarGroup>
        {showNames && (
          <div className="ml-2 flex whitespace-nowrap">
            {chainData.map(
              (singleChain, index) =>
                singleChain && (
                  <div key={`chain_content_${index}`} className="flex align-middle">
                    {index == 0 ? (
                      <p className="hidden text-[12px] leading-[12px] md:inline-block lg:hidden min-[1280px]:inline-block">{singleChain.name}</p>
                    ) : (
                      <p className="hidden text-[12px] leading-[12px] lg:hidden min-[1280px]:inline-block">/{singleChain.name}</p>
                    )}
                  </div>
                )
            )}
          </div>
        )}
      </div>
    )
  );
}
